/**
 * Location name shown in a header location picker (POS and Back Office).
 * Longer names are cut with "..."; the POS header has more room on web, so
 * it cuts later there. Phones cut both at the same length.
 */
export type HeaderLocationPicker = 'pos' | 'backOffice';

const MAX_LEN: Record<HeaderLocationPicker, { web: number; native: number }> =
  {
    pos: { web: 35, native: 25 },
    backOffice: { web: 25, native: 25 },
  };

/** Cut text and unscaled font size for a header location label. */
export function formatHeaderLocationName(
  text: string,
  { isWeb, picker }: { isWeb: boolean; picker: HeaderLocationPicker },
): { text: string; fontSize: number } {
  const maxLen = MAX_LEN[picker][isWeb ? 'web' : 'native'];
  return {
    text: text.length > maxLen ? text.slice(0, maxLen) + '...' : text,
    fontSize: isWeb ? 14 : 16,
  };
}
